import { get } from 'lodash';
import { isNuc } from './env';

declare global {
  interface Window {
    LOGIN_ENV?: string;
    PASSPORT_URL?: string;
  }
}

const isInHospEnv = (typeof window.LOGIN_ENV !== 'undefined' && window.LOGIN_ENV) ? window.LOGIN_ENV === 'uncloud' : process.env.VUE_APP_LOGIN_ENV && process.env.VUE_APP_LOGIN_ENV === 'uncloud';

// 如果定义了全局变量 PASSPORT_URL, 那么他的优先级比 node.js 环境变量高 .
export const PASSPORT_URL = (typeof window.PASSPORT_URL !== 'undefined' && window.PASSPORT_URL) ? window.PASSPORT_URL : process.env.VUE_APP_PASSPORT_URL;

/**
 * 获取私有化登录uri
 */
export const getPrivateLoginPath = () => {
  if (isNuc) {
    return `${window.location.origin}/login?returnUrl=${window.location.origin}/project/list`;
  }

  return `${window.location.origin}/login`;
};

/**
 * 获取登录uri
 */
export const getLoginPath = () => isInHospEnv ? getPrivateLoginPath() : '/login';

export const getAdminLoginPath = () => `${PASSPORT_URL}/login?returnUrl=${location.origin}/admin/`;

/**
 * 科研前台使用自己的登录页, 科研后台使用新UC登录页
 * 由于新uc暂不支持同一个业务方配置两个登录地址, 因此若科研后台新uc检测到未登录会将地址重定向到科研前台的登录页
 * 为了临时避免这个问题, 通过referrer判断页面跳转来源, 若是从科研后台跳转而来, 则将地址重定向到uc的登录页
 * 此方案仅为临时方案, 后续还需推动新uc对多个登录地址的情况作出变更
 */
export const checkReferrer = () => {
  if (!isNuc) {
    return;
  }

  const referrer = get(document, 'referrer') || '';
  const adminReferrer = `${location.origin}/admin`;

  if (referrer.includes(adminReferrer)) {
    location.replace(getAdminLoginPath());
  }
};

